import { IconProps } from './AllIcons';

/** Outlined microphone for a talk-to-text control. */
export const MicGlyph = ({ color = 'currentColor', size = 13, ...props }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke={color}
    strokeWidth={1.5}
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden={'true'}
    {...props}
  >
    <rect x='9' y='3' width='6' height='11' rx='3' />
    <path d='M5 11a7 7 0 0 0 14 0M12 18v3' />
  </svg>
);

/** Small video camera (outlined body, solid lens) for compact footage chips; 4:3, so `size` is the width. */
export const VideoCameraChipGlyph = ({ color = 'currentColor', size = 13, ...props }: IconProps) => (
  <svg width={size} height={size * 0.75} viewBox='0 0 16 12' fill='none' aria-hidden={'true'} {...props}>
    <rect x='0.5' y='0.5' width='10' height='11' rx='1.5' stroke={color} strokeWidth={1.3} />
    <path d='M11 4.2l4.2-2.4v8.4L11 7.8z' fill={color} />
  </svg>
);

const OUTLINE_GLYPH_PROPS = {
  viewBox: '0 0 32 32',
  fill: 'none',
  strokeWidth: 1.6,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': 'true' as const,
};

/** Outlined video camera; pairs with {@link LightningGlyph} on the upload intent cards. */
export const VideoCameraGlyph = ({ color = 'currentColor', size = 19, ...props }: IconProps) => (
  <svg width={size} height={size} stroke={color} {...OUTLINE_GLYPH_PROPS} {...props}>
    <rect x='4' y='8' width='17' height='16' />
    <path d='M21 13l7-4v14l-7-4' />
  </svg>
);

/** Outlined lightning bolt; pairs with {@link VideoCameraGlyph} on the upload intent cards. */
export const LightningGlyph = ({ color = 'currentColor', size = 19, ...props }: IconProps) => (
  <svg width={size} height={size} stroke={color} {...OUTLINE_GLYPH_PROPS} {...props}>
    <path d='M17 3L6 18h9l-1 11 12-15h-9z' />
  </svg>
);
